import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'

import CircleItem from '~/features/circle-info/components/CircleItem'
import CircleList from '~/features/circle-info/components/CircleList'
import { useCircleList } from '~/features/circle-info/queries/useCircleInfo'
import EventInfoCircleSearch from '~/features/event-info/components/EventInfoCircleSearch'
import { useOngoingEvent } from '~/features/main/queries/useMainContents'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import NoData from '~/shared/components/NoData'
import Pagination from '~/shared/components/pagination/Pagination'

type Props = {
  selectedEventId: number
}

function EventInfoSearchCircle({ selectedEventId }: Props) {
  const [searchParams] = useSearchParams()
  // 선택된 값을 저장할 상태를 선언

  const { data: ongoingEvent } = useOngoingEvent()

  const [page, setPage] = useState(1)
  const {
    data: circleList,
    isLoading,
    refetch,
  } = useCircleList(
    10,
    page,
    selectedEventId.toString() || '',
    searchParams.get('search') || '',
  )

  useEffect(() => {
    refetch()
  }, [ongoingEvent])

  if (isLoading) return <LoadingScreen />

  const changePage = (event: any) => {
    if (circleList && page <= circleList?.data.pageInfo.max_page) {
      setPage(Number(event.target.innerText))
    }
  }

  return (
    <Wrapper>
      <EventInfoCircleSearch />
      {circleList && circleList.data.list.length === 0 && <NoData />}
      {circleList && circleList.data && (
        <>
          <CircleList>
            {circleList.data.list.map((circle) => {
              return (
                <CircleItem
                  key={circle.id}
                  circleId={circle.id.toString()}
                  title={circle.booth_name}
                  thumbnailImgSrc={circle.image_info?.url || ''}
                  circleMaster={circle.user_name}
                  circleLink={circle.homepage}
                  zoneTypeDesc={circle.zone_type_desc}
                  dateTypeDesc={circle.date_type_desc}
                  hashtags={
                    circle.tag && circle.tag?.indexOf(',')
                      ? circle.tag.split(',')
                      : [circle.tag]
                  }
                />
              )
            })}
          </CircleList>
          <Pagination
            page={page}
            count={circleList.data.pageInfo.max_page}
            onChange={changePage}
          />
        </>
      )}
    </Wrapper>
  )
}

export default EventInfoSearchCircle

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
`
